import GalleryModal from './GalleryModal';
import './GalleryModal.scss';

export default GalleryModal;
